const vn = {
    common: {
        history: "phiên bản lịch sử"
    }
};
export default vn;



// WEBPACK FOOTER //
// ./src/i18n/langs/vn.js